'use client'
import { useEffect } from 'react'

import { Button } from '@nextui-org/button'
import { useConnectWallet, useWallets } from '@privy-io/react-auth'
import { useAccount, useSwitchChain } from 'wagmi'

import { shortenAddress } from '@/utils'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { useUpdateProfileMutation } from '@/redux/api/profile/profileW3'
import { authActions } from '@/redux/reducers/auth/auth.reducer'
import { cn } from '@/utils/cn'

export const ConnectWalletButton = ({ className }: { className?: string }) => {
  const { chains } = useSwitchChain()
  const { wallets } = useWallets()
  const { chainId, switchChain } = wallets[0] || {}

  const { connectWallet } = useConnectWallet({
    onSuccess: () => {
      const activeChain = chains.map((it) => it.id)?.includes(+chainId)
      if (!activeChain) {
        switchChain(Number(process.env.NEXT_PUBLIC_DEFAULT_CHAIN_ID))
      }
    },
  })
  const { address, isConnected } = useAccount()

  const user = useAppSelector((state) => state.root.auth.user)
  const [UpdateProfile] = useUpdateProfileMutation()
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!isConnected && !address) return

    const handleUpdate = async () => {
      if (user && !user?.walletAddress) {
        const resp = await UpdateProfile({ userID: user?.id, FormData: { walletAddress: address } })
        if (resp.data) {
          dispatch(authActions.setUser(resp.data))
        }
      }
    }
    handleUpdate()
  }, [isConnected, address, dispatch, user?.walletAddress])

  const handleConnect = async () => {
    if (address) return
    connectWallet()
  }

  return (
    <>
      <Button
        className={cn('mt-4 w-full bg-btn-gradient text-base font-medium text-white', className)}
        variant="solid"
        onClick={handleConnect}
      >
        {isConnected ? shortenAddress(address || '') : 'Connect Wallet'}
      </Button>
    </>
  )
}
